import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './Admin.scss';
import { Layout } from './page/Layout';
import { Dashboard } from './page/Dashboard/Dashboard';
import { Supplier } from './page/Supplier/Supplier';
import { Products } from './page/Products/Products';
import { Sale } from './page/Sale/Sale';

const Admin: React.FunctionComponent = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="/suppliers" element={<Supplier />} />
          <Route path="/sales" element={<Sale />} />
          <Route path="/products" element={<Products />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export { Admin };
